<div class="flex flex-col" id="{{baseId + '-entityId-' + entityId}}">
    <div class="flex flex-row gap-4 items-center" [id]="baseId + '-header'">
        <span class="icon-24 text-link material-symbols-rounded" [id]="baseId + '-header-icon'">{{ iconName }}</span>
        <span class="text-link body-large-bold line-clamp-1" [id]="baseId + '-header-title'">{{ searchResultItem?.title }}</span>

        @if (algoliaRecordHit?.entityType == algoliaEntityType.Ballot) {
            <app-status-badge
                [colourScheme]="statusBadgeColourSchemeEnum.Blue2"
                [name]="baseId + '-header-ballot-type-badge'"
            >
                {{algoliaRecordHit && algoliaRecordHit.facetBallotType && algoliaRecordHit.facetBallotType.length > 0 ? algoliaRecordHit.facetBallotType[0] : ''}}
            </app-status-badge>                 

            <app-ballot-status-badge
                [id]="baseId + '-header-ballot-status-badge'"
                [statusId]="algoliaRecordHit?.ballotStatusId">
            </app-ballot-status-badge>

        } @else if (algoliaRecordHit?.entityType == algoliaEntityType.Committee) {
            <app-committee-status-badge
                [name]="baseId + '-header-committee-status-badge'"
                [committeeStatus]="algoliaRecordHit?.committeeStatusForDisplay">
            </app-committee-status-badge>
        } @else if (algoliaRecordHit?.entityType == algoliaEntityType.Project) {
            <app-status-badge
                [colourScheme]="statusBadgeColourSchemeEnum.Green"
                [name]="baseId + '-header-project-phase-badge'"
            >
                {{algoliaRecordHit && algoliaRecordHit.projectPhaseForDisplay ? algoliaRecordHit.projectPhaseForDisplay : ''}}
            </app-status-badge>            

        } @else if (algoliaRecordHit?.entityType == algoliaEntityType.Publication) {
            <app-status-badge
                [colourScheme]="statusBadgeColourSchemeEnum.Green"
                [name]="baseId + '-header-publication-type-badge'"
            >
                {{algoliaRecordHit && algoliaRecordHit.publicationTypeForDisplay ? algoliaRecordHit.publicationTypeForDisplay : ''}}
            </app-status-badge>

            <app-status-badge
                [colourScheme]="statusBadgeColourSchemeEnum.Green"
                [name]="baseId + '-header-publication-status-badge'"
            >
                {{algoliaRecordHit && algoliaRecordHit.publicationStatusForDisplay ? algoliaRecordHit.publicationStatusForDisplay : ''}}
            </app-status-badge>              
        }
    </div>
    <div class="body-default-regular text-black line-clamp-1" [id]="baseId + '-sub-title'">{{ searchResultItem?.subTitle }}</div>
    <div class="body-small-regular text-subtle line-clamp-1" [id]="baseId + '-description'">{{ searchResultItem?.description }}</div>
</div>
